import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, orderBy } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

import { MatrizTarifaPesoEdit } from "./edit";
const EditModal = MatrizTarifaPesoEdit;
type Entity = models.MatrizTarifaPeso;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void>;
    readonly?: boolean;
}

type Column = kea.Grid2Column<Entity>;

const columnasFijas: Column[] = [
    { title: "Peso hasta (kg)", cell: x => ({ data: x.PesoHasta }), },
    { title: "Cubicacion hasta (m³)", cell: x => ({ data: x.CubicaionHasta }), }
];

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [botones, ...columnasFijas];
}

/**
* Listado de MatrizTarifaPeso
*/
class MatrizTarifaPesoListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            const newList = orderBy([...oldList, newItem], x=> x.PesoHasta );
            await this.props.onChange(newList);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = result.value;
            const oldList = this.props.value;
            const newList = orderBy(oldList.map(x => x == item ? newItem : x) , x => x.PesoHasta) ;
            await this.props.onChange(newList);
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.PesoHasta + " kg");
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span>Pesos</span>
                            <div className="pull-right">
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                            </div>
                        </h4>
                    </div>
                </div>

                <kea.Grid2 items={this.props.value} columnas={cols} hideBusqueda={true} />
                {this.modals.component}
            </div>
        );
    }
}
export const MatrizTarifaPesoList = kea.mapProps(componentToRx(MatrizTarifaPesoListNoRx), x => ({...x, value: x.value || []}));



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/edit/componentes/pesos/list.tsx